var $5f9f4b115dc0e870$exports = {};
const $5f9f4b115dc0e870$var$comment = document.getElementById("comment");
const $5f9f4b115dc0e870$var$save = document.querySelector(".save--js");
const $5f9f4b115dc0e870$var$load = document.querySelector(".load--js");
$5f9f4b115dc0e870$var$save.addEventListener("click", ()=>{
    localStorage.setItem("wynik", $5f9f4b115dc0e870$var$comment.value);
    console.log($5f9f4b115dc0e870$var$comment.value);
});
$5f9f4b115dc0e870$var$load.addEventListener("click", ()=>{
    const a = localStorage.getItem("wynik");
    $5f9f4b115dc0e870$var$comment.value = a;
});


//# sourceMappingURL=index.5d256b6d.js.map
